//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { getProductCatalogClients } from '@apis/universal-image-actions/universalImageActionsApi';
import ClientId from '@models/ClientId';
import PartialCuid from '@models/PartialCuid';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export interface CatalogClient {
  clientId: ClientId;
  clientName: string;
}

export const useProductCatalogClientsQuery = (
  cuid: PartialCuid,
  isEnabled: boolean,
) =>
  useQuery({
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsProducts,
      QueryKeyConstants.UniversalImageActionsProductsProductCatalogClients,
      cuid,
    ],
    queryFn: async ({ signal }) =>
      (await getProductCatalogClients({ cuid }, { signal })).map(
        ({ client_id, client_name }) => ({
          clientId: client_id,
          clientName: client_name,
        }),
      ),
    staleTime: FIVE_MINUTES_STALE_TIME,
    enabled: isEnabled,
  });
